import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { FlightLogSummaryActions, FlightLogSummaryActionTypes } from './flight-log-summary.actions';
import { FlightLogSummaryEntity } from './flight-log-summary.model';

export type FlightLogSummaryEntities = EntityState<FlightLogSummaryEntity>;

export const adapter: EntityAdapter<FlightLogSummaryEntity> =
  createEntityAdapter<FlightLogSummaryEntity>();

export const initialState: FlightLogSummaryEntities = adapter.getInitialState({
  // additional entity state properties
});

export function reducer(state = initialState, incomingAction: Action): FlightLogSummaryEntities {
  const action: FlightLogSummaryActions = incomingAction as FlightLogSummaryActions;
  switch (action.type) {
    case FlightLogSummaryActionTypes.AddFlightLogSummary: {
      return adapter.addOne(action.payload.flightLogSummary, state);
    }

    case FlightLogSummaryActionTypes.UpsertFlightLogSummary: {
      return adapter.upsertOne(action.payload.flightLogSummary, state);
    }

    case FlightLogSummaryActionTypes.AddFlightLogSummarys: {
      return adapter.addMany(action.payload.flightLogSummarys, state);
    }

    case FlightLogSummaryActionTypes.UpsertFlightLogSummarys: {
      return adapter.upsertMany(action.payload.flightLogSummarys, state);
    }

    case FlightLogSummaryActionTypes.UpdateFlightLogSummary: {
      return adapter.updateOne(action.payload.flightLogSummary, state);
    }

    case FlightLogSummaryActionTypes.UpdateFlightLogSummarys: {
      return adapter.updateMany(action.payload.flightLogSummarys, state);
    }

    case FlightLogSummaryActionTypes.DeleteFlightLogSummary: {
      return adapter.removeOne(action.payload.id, state);
    }

    case FlightLogSummaryActionTypes.DeleteFlightLogSummarys: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case FlightLogSummaryActionTypes.LoadFlightLogSummarys: {
      return adapter.setAll(action.payload.flightLogSummarys, state);
    }

    case FlightLogSummaryActionTypes.ClearFlightLogSummarys: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
